import classnames from 'classnames';
import { useState } from 'react';
import { useMeasure } from 'react-use';
import { FixedSizeGrid as Grid } from 'react-window';
import { Json as IModel } from '../../types';
import { AssetPackItemMemoized } from './AssetPackList.components';
import { useGridConfig } from './AssetPackList.hooks';
import { Wrapper } from './AssetPackList.style';

export type AssetPackListProps = {
  models: IModel[];
  onPick: (id: string) => void;
  onAction: OnAction;
  onNew: () => void;
};

export function AssetPackList(props: AssetPackListProps) {
  const { models = [] } = props;
  const [hoverId, setHoverId] = useState('');
  const [ref, { width, height }] = useMeasure<HTMLDivElement>();
  const config = useGridConfig(width, models.length);

  const columnCount = config.columns;
  const isTwoColumns = models.length > 7;

  const Cell = (itemProps: any) => {
    const itemIndex = itemProps.rowIndex * columnCount + itemProps.columnIndex;
    const model = models[itemIndex] as Json;

    if (!model) return null;

    return (
      <AssetPackItemMemoized
        key={model.id}
        model={model as any}
        isHovered={hoverId === model.id}
        onPick={props.onPick}
        onAction={props.onAction}
        onMouseOver={setHoverId}
        style={itemProps.style}
      />
    );
  };

  const className = classnames('AssetPackList-wrapper', `col-${columnCount}`, {
    double: isTwoColumns,
  });

  function renderInner() {
    if (!height || !config.thumbnailHeight) return null;

    return (
      <Grid
        columnCount={columnCount}
        rowCount={Math.ceil(models.length / columnCount)}
        columnWidth={config.thumbnailWidth}
        rowHeight={config.thumbnailHeight}
        width={config.gridWidth}
        height={height}
        itemData={models}
        overscanColumnCount={20} // Preload 2 extra columns on each side
        overscanRowCount={20} // Preload 2 extra rows on each side
      >
        {Cell}
      </Grid>
    );
  }

  return (
    <Wrapper className={className} data-testid='AssetPackList-wrapper' ref={ref}>
      {renderInner()}
    </Wrapper>
  );
}

export default AssetPackList;
